import PropTypes from 'prop-types';
/*
TODO: let’s display all cruise advisories as a link: “View cruise advisories (2) <chevron down>”
(2 is an example of how many cruise advisory messages there are) - on click opens popover and shows
the content as we do now, but inside the popover (without the blue background)
*/
const CruiseLineAdvisories = ({
  advisories,
  className,
}) => (advisories && advisories.length > 0
    && (
    <div className={`rounded-lg bg-opacity-10 text-theme bg-theme border border-theme border-opacity-10 font-normal ${className}`}>
      <div className="font-bold">
        Cruise line advisories:
      </div>
      {advisories
        .map((adv) => (
          <div key={adv.advisoryDescription}>
            {adv.advisoryDescription}
            <br />
          </div>
        ))}
    </div>
    ));

CruiseLineAdvisories.propTypes = {
  advisories: PropTypes.arrayOf(PropTypes.shape({
    advisoryDescription: PropTypes.string,
    advisoryCode: PropTypes.string,
  })),
  className: PropTypes.string,
};

CruiseLineAdvisories.defaultProps = {
  className: '',
  advisories: [],
};
export default CruiseLineAdvisories;
